// export const listingStates = {
//   1: "rent", // available for rent
//   2: "sell", // available for sell
//   3: "unavailable",
//   4: "rented",
//   5: "sold",
// };

export const smTypes = {
  instagramPost: 1,
  instagramReel: 2,
  youtubeShort: 3,
  spotifyPodcast: 4,
};

export const listingStates = {
  rent: 1, // available for rent
  sell: 2, // available for sell
  unavailable: 3,
  rented: 4,
  sold: 5,
};

// @Cont: update the data structure
export const propertyTypes = {
  house: {
    id: 1,
    label: "House",
  },
  townHouse: {
    id: 2,
    label: "Townhouse",
  },
  apartment: {
    id: 3,
    label: "Apartment",
  },
};
